<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'Apple'
};
</script>

<style lang="stylus" scoped>
.icon_wrap
  display inline-block
  width 40px
  height 40px
  background-size 40px 40px
  background-repeat no-repeat
  background-position center
  background-image url('./images/cdk_icon_apple.png')
  background-image image-set(url('./images/cdk_icon_apple.png') 1x, url('./images/cdk_icon_apple@2x.png') 2x)
</style>
